<template>
  <div class="home-banner" :style="`margin-top: ${-0}px`">
    <video class="video" src="/video/banner.mp4" autoplay="autoplay" muted loop></video>
    <div class="spec">
      <div class="title">
        永辉人的商品宝典
        <!-- <i class="el-icon-video-play play"></i> -->
      </div>
      <img class="play" src="@/assets/index/播放2.png" @click="onPlay" />
      <div
        class="content"
      >永辉超市作为国内零售领军企业，致力于为满足用户需求，提供安全、健康、高性价比的食品，永辉商品百科全书承载商品知识，沉淀商品文化，助力永辉商品经营，是每个永辉人的商品宝典。</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeBanner",
  data() {
    return {
      scrollTop: 0
    };
  },
  computed: {
    y: function() {
      return (500 - this.scrollTop) / 500;
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll(e) {
      this.scrollTop = e.target.documentElement && e.target.documentElement.scrollTop;

      // console.log(this.scrollTop);
    },
    onPlay() {
      this.$router.push("/cast-screen");
    }
  }
};
</script>

<style lang="less" scoped>
.home-banner {
  // width: 100vw;
  // margin: 0 auto;
  height: 500px;
  overflow: hidden;

  position: relative;

  .play {
    width: 36px;
    height: 35px;
    margin-top: 164px;
    margin-left: 20px;
    vertical-align: top;
    z-index: 3;

    cursor: pointer;
  }

  .video {
    width: 100vw;

    z-index: 1;
  }

  .spec {
    z-index: 2;
    position: absolute;
    top: 0;
    width: 1100px;
    height: 500px;
    padding: 0 calc((100vw - 1100px) / 2);
    // top: 245px;
    // left: ;
    // margin: 0 auto;
    background: linear-gradient(
      270deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.6) 100%
    );
    // opacity: 1;

    text-align: center;
    .title {
      margin-top: 160px;
      margin-bottom: 40px;
      font-size: 40px;
      font-family: "FZQKBYSJW";
      font-weight: normal;
      color: rgba(255, 255, 255, 1);
      line-height: 44px;
      vertical-align: top;
      z-index: 3;
      display: inline-block;
    }

    .content {
      text-align: center;
      margin: 0 auto;
      width: 620px;
      font-size: 18px;
      font-weight: 200;
      color: rgba(255, 255, 255, 1);
      line-height: 34px;
      z-index: 3;
    }
  }
}
</style>